// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"webpack-concepts-Extraction-StudyList-DocumentUploader-module__loadingSpinner"};